import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "_레이어_2",
  "data-name": "레이어 2",
  viewBox: "0 0 612.77 695.88"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#fb8200}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"_레이어_1-2\" data-name=\"레이어 1\"><path d=\"M454.73 695.88H61.31c0-89.01 72.16-161.17 161.17-161.17h384.28v20.14\" style=\"fill:#ffc4c4;\"></path><path d=\"M169.24 181.21c88.95 0 161.17 72.22 161.17 161.17v384.28h-20.14c-77.84 0-141.03-63.19-141.03-141.03z\" style=\"fill:#ffb92b;\" transform=\"rotate(-45 249.827 453.938)\"></path><path d=\"M284.79 0c88.95 0 161.17 72.22 161.17 161.17v522.89h-20.14c-77.84 0-141.03-63.19-141.03-141.03z\" class=\"cls-1\"></path><circle cx=\"448.8\" cy=\"531.56\" r=\"163.96\" class=\"cls-1\"></circle></g>", 1))
  ]))
}
export default { render: render }